<template>
  <div class="swiper_container">
    <el-carousel
      :interval="5000"
      arrow="hover"
      height="590px"
    >
      <el-carousel-item
        v-for="item in list"
        :key="item.id"
      >
        <router-link
          :to="item.to"
        >
          <img
            class="banner_pic"
            :src="item.url"
            alt=""
          >
        </router-link>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'Swiper',
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper_container {
  height: 0px;
  width: 100%;
  overflow: hidden;
  padding-bottom: 590px;
  box-sizing: border-box;
  background-color: #5279e0;
  .el-carousel__item{
    .banner_pic {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
